module.exports = __webpack_public_path__ + "static/media/imagePlaceholder.24d66af2.png";